/**
 * Seconds, shared by choreography, audio and tests. All ignite timings are
 * relative to the "Los geht's" click, which is the single clock for the
 * visuals and the sound.
 */
export const WELCOME_MOTION = {
  ease: [0.16, 1, 0.3, 1] as [number, number, number, number],
  emberEase: [0.22, 1, 0.36, 1] as [number, number, number, number],
  linear: [0, 0, 1, 1] as [number, number, number, number],
  reduced: 0.15,
  // Stage 0: the breathing start button.
  breathe: 3.2,
  startIn: 0.7,
  orbit: 3.6,
  sheen: 1.1,
  sheenPause: 2.4,
  // Stage 1: ignite.
  buttonOut: 0.22,
  emberDelay: 0.12,
  ember: 1.0,
  // The mark lands exactly on the flash: markDelay + mark === flashAt.
  markDelay: 0.1,
  mark: 0.9,
  flashAt: 1.0,
  flashIn: 0.06,
  flashOut: 0.6,
  glowLand: 1.1,
  afterglow: 0.9,
  haloLoop: 5,
  titleAt: 1.3,
  bodyAt: 1.4,
  words: 0.52,
  nextAt: 1.9,
  next: 0.3,
  // Scene transition and scene 2.
  sceneExit: 0.32,
  sceneGap: 0.08,
  // Relative to scene 2 mounting. The last light pass ends at 1.5 s.
  readyTitle: 0.55,
  readyStep: 0.5,
  readyStepDelay: 0.24,
  readyStepStagger: 0.26,
  readyNode: 0.2,
  readyGlint: 0.55,
  readyActionAt: 1.1,
  readyAction: 0.3,
  readySheenAt: 1.12,
  readySheen: 0.38,
  readyInteraction: 0.2,
  exit: 0.32,
  glow: 0.9,
  // Sound, seconds after the click.
  audioHitAt: 1.0,
  audioStop: 2.3,
}
